import BlockAmbassadorText from './BlockAmbassadorText';
export default BlockAmbassadorText;
